<template>
  <main class="main">
      <div class="table">
        <a :href="url" class="export-btn"><app-button class="mt-2">Экспорт в эксель</app-button></a>
        <loading-container :loading="loading" >
        <table >
          <tr>
            <th>ID товара в xml</th>
            <th>Артикул</th>
            <th>Цвет</th>
            <th>Размер</th>
            <th>Ошибка</th>
          </tr>
          <tr v-for="(item, idx) in errors" :key="idx">
            <td>
                {{item.product_id}}
            </td>
            <td>
              {{item.article}}
            </td>
            <td>
              {{item.color}}
            </td>
            <td>
              {{item.size}}
            </td>
            <td>
              {{item.text_error}}
            </td>
          </tr>
        </table>
      </loading-container>
      </div>
      <pagination
          :key="paginat"
          v-show="last_page > 1"
          v-model="page"
          :page-count="last_page"
      />
  </main>
</template>

<script>

import LoadingContainer from "@/components/loading-container";
import Pagination from "@/components/pagination";
import AppButton from "@/components/app-button";

export default {
  name: "import-log-errors",
  components: {
    LoadingContainer,
    Pagination,
    AppButton
  },
  data: ()=>({
    last_page: 0,
    paginat: null,
    page: 0,
    loading: true,
    errors: null,
    url: ''
  }),
  mounted() {
    this.url = `${process.env.VUE_APP_BACKEND_URL}/export-errors?log=${this.$route.params.id}&token=${localStorage.getItem('token')}`
    this.getErrors();
  },
  methods: {
    getErrors(){
      this.$http.post('/get-log-errors', {
        token: localStorage.getItem('token'),
        page:this.page,
        id: this.$route.params.id
      }).then(({data}) => {
        if (data.errors){
          this.errors = data.errors.data;
          this.last_page = data.errors.last_page;
          this.page = data.errors.current_page;
          this.loading = false;
        }
      }).catch((error) => {
        console.log(error)
      })
    }
  },
  watch: {
    page: function (val) {
      if (val >= 1) {
        this.loading = true;
        this.getErrors();
      }
    }
  }
}
</script>

<style scoped lang="scss">
.export-btn {
  width: 200px;
  margin-bottom: 20px;
  display: block;
}
.table{
  margin-top: 20px;
  table{
    background: #FFFFFF;
    box-shadow: 0px 0px 3px #E5E5EA;
    border-radius: 4px;
    tr{
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 14px;

      th{
        color: #2D3137;
      }
      td{
        color: #636974;
        &.done{
          color: #2cb181;
        }
      }
    }
  }
}


</style>
